var _excluded = ["isOpen", "header", "content"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import PreventPageScroll from "../../../helpers/PreventPageScroll";
import FlexItemOrg from "../FlexItemOrg";
import PushOrg from "../PushOrg";
import { Overlay, StyledContainerOrg, StyledWrapOrg } from "./DevicesPreviewModalOrg.styled";
import HeaderMol from "./HeaderMol";
function DevicesPreviewModalOrg(_ref) {
  var isOpen = _ref.isOpen,
    header = _ref.header,
    content = _ref.content,
    restProps = _objectWithoutProperties(_ref, _excluded);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen ? /*#__PURE__*/React.createElement(PreventPageScroll, null) : null, /*#__PURE__*/React.createElement(Overlay, restProps, /*#__PURE__*/React.createElement(StyledContainerOrg, null, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 10
  }, /*#__PURE__*/React.createElement(HeaderMol, header)), /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexBasis: 1,
    flexGrow: 1,
    flexShrink: 1
  }, /*#__PURE__*/React.createElement(StyledWrapOrg, {
    alignCenter: "horizontal",
    gutterSpace: 0
  }, content)))));
}
export default DevicesPreviewModalOrg;